import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=45dda0ad"
import script from "./quotations.ts?vue&type=script&lang=js&external"
export * from "./quotations.ts?vue&type=script&lang=js&external"
import style0 from "./quotations.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports